// Sunucu (backend) adresi — tek yerden. Railway/Render'da REACT_APP_API_URL ile değiştirilebilir
// (derleme sırasında okunur; değiştirince yeniden derleme gerekir).
export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.hatimtakip.com.tr').replace(/\/$/, '');
